<ng-template #modalTmpl>
  <div mat-dialog-content class="max-h-80vh p-0!">
    <div class="p-16px">
      <div class="text-center pt-16px"><b>Are You stll here?</b></div>
      <div class="text-center text-error text-12px mt-16px">
        Auto logout in <ib-time-diff [timestamp]="finishAt"></ib-time-diff>
      </div>
    </div>
  </div>
  <div
    mat-dialog-actions
    class="border-t border-border-d flex justify-end items-center p-16px"
  >
    <button mat-button (click)="here()" class="ib-btn-secondary">
      Yes, I am here
    </button>
  </div>
</ng-template>
